import { render, staticRenderFns } from "./ReplenishInfo.vue?vue&type=template&id=8b71ca4c&scoped=true"
import script from "./ReplenishInfo.vue?vue&type=script&lang=js"
export * from "./ReplenishInfo.vue?vue&type=script&lang=js"
import style0 from "./ReplenishInfo.vue?vue&type=style&index=0&id=8b71ca4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b71ca4c",
  null
  
)

export default component.exports